import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryPreview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            视频分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">八大品类，满足你的每一种观看需求</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 text-center">{cat.description}</p>
              <span className="mt-2 text-xs text-foreground-400 whitespace-nowrap">{cat.count} 部精选</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}